import(/* webpackMode: "eager" */ "C:\\Users\\User\\Documents\\NEW SITE 9\\magikalcandy\\src\\app\\page.tsx");
